import React from 'react';
import './RetroTextarea.css';

function RetroTextarea({
  id,
  name,
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  label,
  error,
  hint,
  rows = 4,
  className = '',
  ...props
}) {
  return (
    <div className={`retro-textarea-wrapper ${className}`}>
      {label && (
        <label htmlFor={id} className="retro-textarea-label">
          {label}
          {required && <span className="retro-textarea-required"> *</span>}
        </label>
      )}

      <textarea
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        rows={rows}
        className={`retro-textarea ${error ? 'retro-textarea-error' : ''} ${disabled ? 'retro-textarea-disabled' : ''}`}
        {...props}
      />

      {error && <div className="retro-textarea-error-message">{error}</div>}
      {hint && !error && <div className="retro-textarea-hint">{hint}</div>}
    </div>
  );
}

export default RetroTextarea;
